var React = require('react');

function TridentCapInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 35L6 8","stroke":"#282828","key":0}),React.createElement("path",{"d":"M0.999997 8.74228e-07L1 30.002L6 35.002L11 30.002L11 0","stroke":"#282828","key":1})]);
}

TridentCapInline.defaultProps = {"width":"12","height":"36","viewBox":"0 0 12 36","fill":"none"};

module.exports = TridentCapInline;

TridentCapInline.default = TridentCapInline;
